import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class OpenTicketIssueSubCategory extends Component {
    state = {
        OpenTicketIssueSubCategoryLists:[],
        OpenTicketIssueSubCategoryValue: '',
        isOpenTicketIssueSubCategoryLoading: true
    };
    componentDidMount(){
        this.getOpenTicketIssueSubCategory();
    }
    restOpenTicketIssueSubCategoryFilter() {
        this.setState({
            OpenTicketIssueSubCategoryValue: [],
        })
    }
    getOpenTicketIssueSubCategory(){
        axios.get(config.get('API_URL')+'/filters/get-ticket-sub-category/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((cf_issue_sub_category, index) => {
                    this.state.OpenTicketIssueSubCategoryLists.push({value: cf_issue_sub_category.cf_issue_sub_category, label: cf_issue_sub_category.cf_issue_sub_category})
                });
            }
            this.setState({
                isOpenTicketIssueSubCategoryLoading: false
            })
        });

    }


    changeOpenTicketIssueSubCategory(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.OpenTicketIssueSubCategoryLists.findIndex(obj => obj.value==ids.value);
                this.state.OpenTicketIssueSubCategoryLists.move(index,0).join(',');
            });
        }
        this.props.onSelectOpenTicketIssueSubCategory(optionSelected, tenderArray);
        this.setState({
            OpenTicketIssueSubCategoryValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.OpenTicketIssueSubCategoryValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeOpenTicketIssueSubCategory.bind(this)}
                options={this.state.OpenTicketIssueSubCategoryLists}
                placeholderButtonLabel="Select [Issue Type]"
                isLoading={this.state.isOpenTicketIssueSubCategoryLoading}
            />
        );

    }
}
export default OpenTicketIssueSubCategory;